<template>
<div>
  <v-container v-resize="onResize"  fluid :width="wwidth" style="margin:0px;padding:0px;">
  <v-layout>
  <v-flex :xs6="editing" :xs12="!editing">
  <v-row class="fill-height">
    <v-col style="margin: 0px; margin-left:15px;margin-right: 15px; padding: 0px;">
      <v-sheet height="64">
        <v-toolbar flat >
          <v-btn outlined class="mr-4"  @click="setToday">
            Today
          </v-btn>
          <v-btn fab text small  @click="prev">
            <v-icon small> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn fab text small @click="next">
            <v-icon small> mdi-chevron-right </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <div class="pl-6">
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined  v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item @click="type = '4day'">
                <v-list-item-title>4 days</v-list-item-title>
              </v-list-item> -->
            </v-list>
          </v-menu>
          </div>
          <v-spacer></v-spacer>
          <v-btn color="blue"  dark @click="addItem()" v-if="!editing">
            New Task
          </v-btn>
          
        </v-toolbar>
      </v-sheet>
      <v-sheet :height="wheight" style="padding: 0px;">
        <v-calendar v-if="redraw"
          first-time="8"
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card :dark="dark"  min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-btn icon v-if="selectedEvent.thisItem && (user._id == selectedEvent.thisItem.creator || selectedEvent.thisItem.responsible.includes(user._id) || selectedEvent.thisItem.visibility.includes(user._id))">
                <v-icon @click="editItem(selectedEvent)">mdi-pencil</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn v-if="selectedEvent.thisItem && user._id == selectedEvent.thisItem.creator" icon>
                <v-icon @click="deleteItem(selectedEvent)">mdi-delete</v-icon>
              </v-btn>
              <!-- <v-btn icon>
                <v-icon>mdi-mail</v-icon>
              </v-btn> -->
            </v-toolbar>
            <v-card-text>
              <h4>
              <span>Priority: &nbsp;</span><span :class="getRecordColor(selectedEvent.priority) + '--text'">
                {{selectedEvent.priority}}</span>
              </h4>
              <h4>
                <span>Status: &nbsp;</span>
                {{selectedEvent.status}}<span></span>
              </h4>
              <h4>
                <span>Created By: &nbsp;</span>
                {{selectedEvent.creator}}
              </h4>
              <h4>
                <span>Assigned To: &nbsp;</span>
                {{selectedEvent.responsible}}
              </h4>
              <span>{{selectedEvent.details}}</span>
            </v-card-text>
            <v-card-actions>
              <v-btn text @click="selectedOpen = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
    </v-flex>
  <v-flex :xs6="editing" v-if="editing">
    <Task :taskInit="initialValue" :closeTask.sync="closeOrSave"/>

  </v-flex>
  </v-layout>
  </v-container>
  </div>
</template>

<script>
import axiosInstances from "@/../../coreui/server/axiosInstances";
import moment from 'moment';
import { sync }  from 'vuex-pathify'
import Task from './Task'
import preprocess from '@/../../coreui/helpers/preprocess'
export default {
  components: {
    Task
  },
  data: () => ({
    redraw: true,
    closeOrSave: {'op': 'close'},
    editing: false,
    initialValue: {},
    checkForErrors: false,
    errors: {},
    startDate: null,
    endDate: null,
    // headers: [],
    // editables: [],
    editedIndex: -1,
    editedItem: {},
    wheight: 300,
    wwidth: 400,
    focus: "",
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
  }),
  computed: {
    user: sync('login/origLoggedinUser'),
    dark: sync('misc/dark')
  },
  mounted() {
    this.$refs.calendar.checkChange();
  },
  watch : {
    closeOrSave: {
      deep: true,
      handler (val) {
        console.log(val)
        if (val.op == 'close') {
          this.editing = false
        } else if (val.op == 'save') {
          this.editing = false
          this.redraw = false
          var self = this
          setTimeout(async function() {
            await self.updateRange({start: self.startDate, end: self.endDate})
            self.redraw = true
          }, 100)
        }
      }
    }
  },
  methods: {
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      if (this.windowSize.y != this.lastheight) {
        this.height = this.windowSize.y
        this.lastheight = this.height
        this.wheight = window.innerHeight - 160
        this.wwidth = this.windowSize.x
      }
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color
    },
    addItem() {
      this.initialValue = {}
      this.editing = !this.editing
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    deleteItem(item) {
      let id = item.thisItem._id
      let self = this
      this.$root
        .$confirm("Delete", "Are you sure you want to delete this task?", {
          color: "red",
        })
        .then(async function (confirm) {
          if (confirm) {
            self.redraw = false
            await axiosInstances.origApiServer.delete(
              "/dt/v1/fac_calendar" + "/" + id
            )
            self.redraw = true
            // setTimeout(async function() {
            //   await self.updateRange({start: self.startDate, end: self.endDate})
            // }, 100)
          }
        });
    },
    editItem(item) {
      this.initialValue = item.thisItem
      this.editing = true
      this.selectedOpen = false
    },
    showEvent({ nativeEvent, event }) {
      console.log('Event: ', event)
      const open = () => {
        this.selectedEvent = event;
        this.editedItem = event.thisItem
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    
    getRecordColor(level) {
      switch(level) {
        case 'Low': 
        return 'blue'
        break
        case 'Medium': 
        return 'green'
        break
        case 'High': 
        return 'orange'
        break
        case 'Critical': 
        return 'red'
        break
        // default: return 'orange'
      }
    },
  
  
    async updateRange({ start, end }) {
      this.startDate = start
      this.endDate = end
      let events = [];
      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      let records = await this.fetchEventsInDateRange(min, max);
      records = !records[0] || records[0].pages != undefined ? records[0].pages : [];
      let employees = await axiosInstances.loginServer.get('dt/v1/users?orgonly')
      // const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = records.length; 

      for (let i = 0; i < eventCount; i++) {
        let color = this.getRecordColor(records[i].priority)
        let names = ''
        let res = records[i]['responsible']
        for (let j = 0; j< res.length; j++) {
          if (j != 0) names += ', '
          let n 
          try {
            n= await axiosInstances.loginServer.get('dt/v1/users/' + res[j])
          } catch (e) {
            console.log(e)
          }
          if (n == null || n.data == null) continue
          // console.log(n, res[j])
          let name = n.data['firstname'] + ' ' + n.data['lastname']
          // console.log(name)
          names += name
        }
        let cid = records[i].creator
        let cname = 'Unknown'
        if (cid) {
          if (cid[0] == '@') {
            cname = 'Entrinsia B.O.T.S.'
          } else {
            res = await axiosInstances.loginServer.get('dt/v1/users/' + cid)
            if (res && res.data) {
              cname = res.data['firstname'] + ' ' + res.data['lastname']
            }
          }
        }
        
        // console.log(names)
        events.push({
          name: records[i]["topic"], 
          start: new Date(records[i]["start"]),
          end: new Date(records[i]["end"]),
          details: records[i]['desc'],
          creator: cname,
          responsible: names,
          color: color, 
          timed: moment(records[i]['start']).isSame(moment(records[i]['end']), 'day'),
          priority: records[i]['priority'],
          status: records[i]['status'],
          thisItem: records[i],
        });
      }
      this.events = events
    },

    async fetchEventsInDateRange(start, end) {
      let pipe = [
        {
          $match: {
            $expr: {
              $ne: ["$IsUsed", "no"],
            },
          },
        },
        {
          $addFields: {
            dbstart: "$start",
          },
        },
        {
          $addFields: {
            dbend: "$end",
          },
        },
        {
          $addFields: {
            de: end,
          },
        },
        {
          $addFields: {
            ds: start,
          },
        },
        {
          $match: {
            $expr: { $not : {
              $or: [
                {
                  $and: [
                    { $lt: ["$dbstart", "$ds"] },
                    { $lt: ["$dbend", "$ds"] },
                  ],
                },
                {
                  $and: [
                    { $gt: ["$dbstart", "$de"] },
                    { $gt: ["$dbend", "$de"] },
                  ],
                },
              ],
            }, },
          },
        },
        {
          $project: {
            dbstart: 0,
            dbend: 0,
            de: 0,
            ds: 0,
          },
        },
        {
          $facet: {
            pages: [
              {
                $skip: 0,
              },
              {
                $limit: 10,
              },
            ],
            total: [
              {
                $count: "count",
              },
            ],
          },
        },
      ];
      const ur = "/misc/dbops?c=fac_calendar&op=pipe";
      const resP = await axiosInstances.origApiServer.post(ur, pipe);
      console.log('Fetched events: ',resP.data)
      if (resP == null || resP.data == null) return [];
      else return resP.data;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },
  async mounted() {
    this.wheight = window.innerHeight - 160
    this.wwidth = window.innerWidth 
  },
};
</script>
